module.exports = __webpack_public_path__ + "static/media/image-black.cd7e0962.svg";